export interface NavItem {
  labelId: string;
  labelDefault: string;
  section: string;
  icon: "calendar" | "campaigns" | "dashboard" | "insights" | "review";
  disabled?: boolean;
}

export const INTEGRATIONS_SECTION = "/integrations";
export const INSTAGRAM_INTEGRATION_SECTION = "/integrations/instagram";

export const isSidebarExactPathActive = (pathname: string, href: string): boolean =>
  pathname === href;

export const isSidebarNestedPathActive = (pathname: string, href: string): boolean =>
  pathname === href || pathname.startsWith(`${href}/`);

export const NAV_ITEMS: NavItem[] = [
  {
    labelId: "sidebar.dashboard",
    labelDefault: "Home",
    section: "/pulse",
    icon: "dashboard",
  },
  {
    labelId: "sidebar.approvals",
    labelDefault: "Approvals",
    section: "/review",
    icon: "review",
  },
  {
    labelId: "sidebar.calendar",
    labelDefault: "Calendar",
    section: "/calendar",
    icon: "calendar",
  },
  {
    labelId: "sidebar.campaigns",
    labelDefault: "Campaigns",
    section: "/campaigns",
    icon: "campaigns",
  },
  {
    labelId: "sidebar.insights",
    labelDefault: "Insights",
    section: "/insights",
    icon: "insights",
  },
];
